import { createContext, useContext, useState } from 'react'

export type ProfessionalFooterContextType = {
  /** Used to add padding to the footer if the floating start journey button is visible. */
  isFloatingStartJourneyButtonVisible: boolean
  setIsFloatingStartJourneyButtonVisible: (isVisible: boolean) => void
}

export const ProfessionalFooterContext = createContext<ProfessionalFooterContextType>({
  isFloatingStartJourneyButtonVisible: false,
  setIsFloatingStartJourneyButtonVisible: () => {},
})

export const useProfessionalFooterContext = () => {
  const context = useContext(ProfessionalFooterContext)
  if (!context) {
    throw new Error('useProfessionalFooterContext must be used within a ProfessionalFooterProvider')
  }
  return context
}

export const ProfessionalFooterProvider = ({ children }: { children: React.ReactNode }) => {
  const [isFloatingStartJourneyButtonVisible, setIsFloatingStartJourneyButtonVisible] = useState(false)

  return (
    <ProfessionalFooterContext.Provider
      value={{ isFloatingStartJourneyButtonVisible, setIsFloatingStartJourneyButtonVisible }}
    >
      {children}
    </ProfessionalFooterContext.Provider>
  )
}
